import { AiOrderEntryRequestStatus } from './AiOrderEntryRequestStatus';

export class AiOrderEntryRequest {
  id: number;
  requestId: string;
  status: AiOrderEntryRequestStatus;
  submittedAt: string;
  errorMessage?: string;

  constructor(opts: AiOrderEntryRequest) {
    this.id = opts.id;
    this.requestId = opts.requestId;
    this.status = opts.status;
    this.submittedAt = opts.submittedAt;
    this.errorMessage = opts.errorMessage;
  }
}
